import { render, staticRenderFns } from "./LoadingCreaSpedizione.vue?vue&type=template&id=83dfe22c"
import script from "./LoadingCreaSpedizione.vue?vue&type=script&lang=ts"
export * from "./LoadingCreaSpedizione.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83dfe22c')) {
      api.createRecord('83dfe22c', component.options)
    } else {
      api.reload('83dfe22c', component.options)
    }
    module.hot.accept("./LoadingCreaSpedizione.vue?vue&type=template&id=83dfe22c", function () {
      api.rerender('83dfe22c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/loading-templates/LoadingCreaSpedizione.vue"
export default component.exports